import React, { memo } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import IconBackspace from '@material-ui/icons/BackspaceSharp'

const ButtonWrapper = memo(({ value, click, disabled, className }) => {
  if (!value) {
    return <div style={{ height: '100%' }} />;
  }
  
  return (
    <Button onClick={() => click(value)} disabled={disabled} className={className}>
      {value === 'backspace' ? <IconBackspace /> : value}
    </Button>
  );
});

ButtonWrapper.defaultProps = {
  value: undefined,
  disabled: false,
};

ButtonWrapper.propTypes = {
  click: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
};

export default ButtonWrapper;
